module.exports = __webpack_public_path__ + "static/media/phone_ringing.63ad1be7.svg";